import * as React from 'react';
const UpChart = (props) => (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 0.72 0.72"
    id="up-trend-round"
    data-name="Flat Color"
    xmlns="http://www.w3.org/2000/svg"
    className="icon flat-color"
    {...props}
  >
    <path
      id="primary"
      d="M0.63 0.18h-0.12a0.03 0.03 0 0 0 0 0.06h0.048l-0.153 0.153 -0.078 -0.078a0.06 0.06 0 0 0 -0.085 0l-0.174 0.174a0.03 0.03 0 0 0 0 0.043 0.03 0.03 0 0 0 0.043 0l0.174 -0.174 0.078 0.078a0.06 0.06 0 0 0 0.085 0L0.6 0.282V0.33a0.03 0.03 0 0 0 0.06 0V0.21a0.03 0.03 0 0 0 -0.03 -0.03"
      // style={{
      //   fill: 'rgb(0, 0, 0)'
      // }}
    />
  </svg>
);
export default UpChart;
